var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconThirdCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "64 64 896 896",
    focusable: "false",
    "data-icon": "press",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true",
    preserveAspectRatio: "xMidYMid slice",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-icon-thirdCheck"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-thirdCheck",
    clipPath: "url(#clip-icon-thirdCheck)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M689.677,961.387c-96.335,0-174.71-78.375-174.71-174.71s78.375-174.709,174.71-174.709,174.71,78.374,174.71,174.709S786.012,961.387,689.677,961.387Zm0-293.419a118.71,118.71,0,1,0,118.71,118.709A118.844,118.844,0,0,0,689.677,667.968Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M682.322,876.995a28,28,0,0,1-21.062-9.55l-51.871-59.221a28,28,0,1,1,42.125-36.9l29.68,33.885,54.24-68.774a28,28,0,1,1,43.971,34.678l-75.1,95.22a28,28,0,0,1-21.264,10.653Q682.682,876.995,682.322,876.995Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M517.419,959.839H232.613a73.082,73.082,0,0,1-73-73V137.613a73.082,73.082,0,0,1,73-73H791.387a73.083,73.083,0,0,1,73,73v479.9a28,28,0,0,1-56,0v-479.9a17.02,17.02,0,0,0-17-17H232.613a17.02,17.02,0,0,0-17,17V886.839a17.019,17.019,0,0,0,17,17H517.419a28,28,0,0,1,0,56Z",
    fill: "currentColor"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u5716\\u5C64_5",
    "data-name": "\\u5716\\u5C64 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M500.786,357.324q22.009,0,37.922-12.92t15.911-37.085a44.311,44.311,0,0,0-12.681-31.7q-12.684-13.279-34.213-13.279-14.6,0-24.046,4.067a38.707,38.707,0,0,0-14.953,10.767A80.994,80.994,0,0,0,458.318,294.4q-4.906,10.532-8.972,19.859-2.394,5.023-8.614,7.9a33.93,33.93,0,0,1-14.355,2.871q-9.572,0-17.585-7.775t-8.016-20.7q0-12.438,7.537-26.2t22.012-26.2q14.473-12.438,36.008-19.978t48.091-7.536a134.152,134.152,0,0,1,42.348,6.34,99,99,0,0,1,33.257,18.3,79.1,79.1,0,0,1,21.294,27.754,81.141,81.141,0,0,1,7.178,33.975q0,23.926-10.407,41.032t-29.788,33.377a131.911,131.911,0,0,1,31.462,22.969,85.847,85.847,0,0,1,25.72,62.446,105.7,105.7,0,0,1-8.732,42.109,107.466,107.466,0,0,1-25.721,36.248,122.63,122.63,0,0,1-40.315,24.883q-23.328,8.971-51.56,8.972-28.71,0-51.44-10.288T420.276,539.04q-14.715-15.43-22.251-31.94t-7.537-27.276q0-13.873,8.972-22.37t22.371-8.494a23.791,23.791,0,0,1,12.92,3.948q6.219,3.948,8.135,9.45,12.438,33.26,26.677,49.407t40.076,16.15a60.226,60.226,0,0,0,28.59-7.3,59.6,59.6,0,0,0,22.73-21.653q8.972-14.355,8.973-33.257,0-27.993-15.313-43.9t-42.588-15.91q-4.788,0-14.834.957t-12.92.957q-13.161,0-20.337-6.58t-7.177-18.3a22.811,22.811,0,0,1,8.613-18.543q8.613-7.055,25.6-7.058Z",
    fill: "currentColor"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThirdCheck);
export default __webpack_public_path__ + "static/media/icon-thirdCheck.66b155cd350048174b2d0c12aa419a53.svg";
export { ForwardRef as ReactComponent };